import React from 'react';
import styled from '@emotion/styled';
import { H4 } from '../../../../ui';
import ReceiptLongOffIcon from '../../../../../assets/receipt-long-off.svg';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { Color } from '../../../shared/styles/Color';

export const NoSearchResultsMessage = () => {
	const { t } = useTranslation();

	return (
		<StyledContainer>
			<StyledIcon />
			<StyledTitle>{t('news_no_search_results_title')}</StyledTitle>
			<StyledBody>{t('news_no_search_results_body')}</StyledBody>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin: 80px 0 124px;
`;

const StyledIcon = styled(ReceiptLongOffIcon)`
	width: 44px;
	height: 44px;
	margin-bottom: 16px;
`;

const StyledTitle = styled(H4)`
	margin-bottom: 8px;
	font-weight: 800;
	line-height: 28.8px;
	color: ${Color.TextBlack};
`;

const StyledBody = styled.p`
	line-height: 21.6px;
	// Overrides max-width from ContentWrap
	max-width: 293px !important;
	text-align: center;
`;
